import React, {useState} from 'react';
import {easyOnboardIc} from 'assets/images/images';
import {DashboardLayout} from 'components';
import Navbar from './components/Navbar';
import PreviewScreen from './components/PreviewScreen';
import {useFlowData} from '../EditProcess/hooks/useFlowData';
import {useParams} from 'react-router-dom';
import {useQuery} from 'react-query';
import {fetchVersionRules} from '../../../../requests/queries/flows';
import {v4} from 'uuid';
import {transformRulesData} from './hooks/ruleUtils';

function VersionRules() {
  const FLowData = useFlowData();
  const [rules, setRules] = useState([]);
  const {version, slug} = useParams();

  const {data: versionRules, isLoading} = useQuery(
    ['version-rules', {version, slug}],
    () => fetchVersionRules({flow_id: slug, version_id: version}),
  );

  React.useEffect(() => {
    if (!isLoading) {
      const flowArray = versionRules?.data?.rules || [];

      const newTempFlow = flowArray.map(({...rule}) => {
        const currentConditions =
          rule?.conditions || rule?.rule?.conditions || {};
        const currentEvent = rule?.event || rule?.rule?.event || {};
        const conditionKey = Object.keys(currentConditions)[0];

        return {
          key: v4(),
          ...(rule.rule || rule),
          id: rule?.rule?.id || rule?.id || '',
          risk_score: currentEvent?.params?.risk_score,
          currentRuleCondition: conditionKey,
          configurations: conditionKey ? currentConditions[conditionKey] : [],
        };
      });
      setRules(transformRulesData(newTempFlow));
    }
  }, [isLoading, versionRules?.data?.rules]);

  return (
    <DashboardLayout
      bg="bg-[#DAE4F4]"
      fullScreen
      topPadding="pt-0 "
      leftMargin="ml-0"
      xlLeftMargin="xl:ml-0"
      xlRightPadding="sm:pr-0 !pr-0"
      breadCrumbs={
        <div className="flex items-center">
          <img src={easyOnboardIc} alt="" />
          <p className="ml-2 -mb-1">Fraud detection</p>
        </div>
      }
    >
      <Navbar rules={FLowData.rules} noNav />
      <div className="relative w-full">
        <PreviewScreen
          rules={rules}
          noPreviewBtn
          isEditorOpen={false}
          versionLabel={versionRules?.data}
        />
      </div>
    </DashboardLayout>
  );
}

export default VersionRules;
